import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const CYCLE = 90000;
const VISIBLE = 7000;
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let cycleTimer: ReturnType<typeof setInterval>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, VISIBLE);
    };
    const startTimer = setTimeout(() => {
      show();
      cycleTimer = setInterval(show, CYCLE);
    }, FIRST_DELAY);
    return () => {
      clearTimeout(startTimer);
      clearTimeout(hideTimer);
      clearInterval(cycleTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-24 left-3 z-40 sm:left-5 lg:bottom-6" data-id="element-172" data-mp="1z413zsm5tiuh">
      <AnimatePresence data-id="element-173" data-mp="235cx4848sm7f">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${index}`} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex max-w-[19rem] items-start gap-3 border-l-4 border-safety bg-concrete-800 py-3 pl-3 pr-2 shadow-slab" data-id="element-174" data-mp="284zbwlzpyaic">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-175" data-mp="rpy1b7nrs0dw" />
            <div className="min-w-0 flex-1" data-id="element-176" data-mp="201hoxsd8r979">
              <p className="text-sm leading-snug text-concrete-50" data-id="element-177" data-mp="200gdhmsbckp0">
                <span className="font-bold" data-id="element-178" data-mp="1v3px0ycljn32">{buyer.name}</span> compró el pack hace{' '}
                {buyer.minutes} min
              </p>
              <p className="mt-0.5 truncate text-xs text-concrete-400" data-id="element-179" data-mp="28tjq5sv4wtil">
                {buyer.place} · Compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso de compra" className="shrink-0 rounded-sm p-1 text-concrete-400 transition-colors duration-150 ease-out hover:text-concrete-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-safety" data-id="element-180" data-mp="1h2dkkwwna3lx">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="31i7czsvj7qy9" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}